import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { format } from 'date-fns'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import { EmpiricalConceptConfig, WizardConfiguration } from '../model/models'

export class ConfigurationAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.getConfiguration = this.getConfiguration.bind(this)
  }

  /**
   *
   */
  public getConfiguration(): Promise<WizardConfiguration> {
    const endpoint = `/configuration`
    return this.get<WizardConfiguration>(endpoint)
      .then((response: AxiosResponse<WizardConfiguration>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  /**
   *
   */
  public triggerAnalysis(startValue: Date) {
    const endpoint = `configuration/import`
    return this.post(endpoint, { time_of_import: format(startValue, 'yyyy-MM-dd') })
      .then((response: AxiosResponse) => response.data)
      .catch((error) => {
        throw error
      })
  }

  /**
   *
   * @param contextModelId
   */
  public empiricalConceptConfigForIndependentCharacteristics(
    contextModelId: number,
  ): Promise<EmpiricalConceptConfig[]> {
    const endpoint = `/configuration/context-model/${contextModelId}/independent-characteristic`
    return this.get<EmpiricalConceptConfig[]>(endpoint)
      .then((response: AxiosResponse<EmpiricalConceptConfig[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }

  /**
   *
   * @param contextModelId
   */
  public empiricalConceptConfigForDescriptiveCharacteristics(
    contextModelId: number,
  ): Promise<EmpiricalConceptConfig[]> {
    const endpoint = `/configuration/context-model/${contextModelId}/descriptive-characteristic`
    return this.get<EmpiricalConceptConfig[]>(endpoint)
      .then((response: AxiosResponse<EmpiricalConceptConfig[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }
}

export const configurationAPI = new ConfigurationAPI(httpConfig)
